/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-26 11:15:34
 */
import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import storageSession from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";
import rootReducer from "@root/reducers/rootReducer";
const persistedReducer = persistReducer(
  {
    key: "village_platForm", // 必须有的
    storage: storageSession,
  },
  rootReducer
);
export const store = configureStore({
  reducer: persistedReducer,
  //@ts-ignore
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    }).concat(logger);
  },
});
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
